var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({ width: '100%', height: '100%' })},[(_vm.detailList.length === 0)?_c('div',{staticClass:"emptyContainer"},[_vm._v("暂无数据")]):_vm._e(),_vm._l((_vm.detailList),function(item,index){return _c('div',{key:index,attrs:{"id":"historyItems"}},[_vm._v(" "+_vm._s(index + 1)+". "+_vm._s(item.todo9)+", 由 "),_c('span',{style:({ fontWeight: 'bold' })},[_vm._v(" "+_vm._s(item.todo10)+" ")]),_vm._v(" "+_vm._s(item.todo11)+"。 "),(!!item.todo12)?_c('div',{style:({
        backgroundColor: '#f9f9f9',
        border: '1px solid #eeeeee',
        boxSizing: 'border-box',
        padding: '10px',
        marginTop: '5px',
        marginLeft: '10px',
      }),domProps:{"innerHTML":_vm._s(item.todo12)}}):_vm._e()])})],2)}
var staticRenderFns = []

export { render, staticRenderFns }